import React from 'react'
import side_image from '../assets/side_image.png';


const RightImage = () => {
  return (
    <div className="right">
        <img src={side_image} class="img"/>
    </div>
  )
}

export default RightImage